var cov_w2usndpe4 = function () {
  var path = '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/report_type/workflow/workflowCtrl.js',
      hash = 'b88f3c4193e755721ef0d1d13561b7e29d734d06',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/report_type/workflow/workflowCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 117,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 15
        },
        end: {
          line: 2,
          column: 21
        }
      },
      '2': {
        start: {
          line: 3,
          column: 23
        },
        end: {
          line: 3,
          column: 33
        }
      },
      '3': {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 26
        }
      },
      '4': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 19,
          column: 4
        }
      },
      '5': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 28
        }
      },
      '6': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 18,
          column: 7
        }
      },
      '7': {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 13,
          column: 7
        }
      },
      '8': {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 41
        }
      },
      '9': {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 54
        }
      },
      '10': {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 29
        }
      },
      '11': {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 36
        }
      },
      '12': {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 31
        }
      },
      '13': {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 17,
          column: 22
        }
      },
      '14': {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 31,
          column: 4
        }
      },
      '15': {
        start: {
          line: 21,
          column: 15
        },
        end: {
          line: 21,
          column: 33
        }
      },
      '16': {
        start: {
          line: 22,
          column: 18
        },
        end: {
          line: 22,
          column: 54
        }
      },
      '17': {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 30,
          column: 7
        }
      },
      '18': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 62,
          column: 4
        }
      },
      '19': {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 61,
          column: 7
        }
      },
      '20': {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 47,
          column: 7
        }
      },
      '21': {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 46,
          column: 15
        }
      },
      '22': {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 30
        }
      },
      '23': {
        start: {
          line: 49,
          column: 27
        },
        end: {
          line: 49,
          column: 45
        }
      },
      '24': {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 60,
          column: 9
        }
      },
      '25': {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 58,
          column: 9
        }
      },
      '26': {
        start: {
          line: 52,
          column: 10
        },
        end: {
          line: 55,
          column: 13
        }
      },
      '27': {
        start: {
          line: 56,
          column: 10
        },
        end: {
          line: 56,
          column: 35
        }
      },
      '28': {
        start: {
          line: 57,
          column: 10
        },
        end: {
          line: 57,
          column: 17
        }
      },
      '29': {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 24
        }
      },
      '30': {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 89,
          column: 4
        }
      },
      '31': {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 45
        }
      },
      '32': {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 31
        }
      },
      '33': {
        start: {
          line: 66,
          column: 21
        },
        end: {
          line: 66,
          column: 46
        }
      },
      '34': {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 73,
          column: 5
        }
      },
      '35': {
        start: {
          line: 68,
          column: 20
        },
        end: {
          line: 68,
          column: 72
        }
      },
      '36': {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 71,
          column: 7
        }
      },
      '37': {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 17
        }
      },
      '38': {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 39
        }
      },
      '39': {
        start: {
          line: 74,
          column: 14
        },
        end: {
          line: 74,
          column: 88
        }
      },
      '40': {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 79,
          column: 5
        }
      },
      '41': {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 40
        }
      },
      '42': {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 79
        }
      },
      '43': {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 88,
          column: 7
        }
      },
      '44': {
        start: {
          line: 90,
          column: 2
        },
        end: {
          line: 92,
          column: 4
        }
      },
      '45': {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 58
        }
      },
      '46': {
        start: {
          line: 93,
          column: 2
        },
        end: {
          line: 93,
          column: 24
        }
      },
      '47': {
        start: {
          line: 94,
          column: 2
        },
        end: {
          line: 115,
          column: 4
        }
      },
      '48': {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 27
        }
      },
      '49': {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 114,
          column: 7
        }
      },
      '50': {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 113,
          column: 7
        }
      },
      '51': {
        start: {
          line: 98,
          column: 25
        },
        end: {
          line: 103,
          column: 9
        }
      },
      '52': {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 109,
          column: 11
        }
      },
      '53': {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 105,
          column: 30
        }
      },
      '54': {
        start: {
          line: 106,
          column: 10
        },
        end: {
          line: 106,
          column: 34
        }
      },
      '55': {
        start: {
          line: 107,
          column: 10
        },
        end: {
          line: 107,
          column: 37
        }
      },
      '56': {
        start: {
          line: 108,
          column: 10
        },
        end: {
          line: 108,
          column: 33
        }
      },
      '57': {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 111,
          column: 31
        }
      },
      '58': {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 112,
          column: 31
        }
      },
      '59': {
        start: {
          line: 116,
          column: 2
        },
        end: {
          line: 116,
          column: 22
        }
      },
      '60': {
        start: {
          line: 120,
          column: 2
        },
        end: {
          line: 120,
          column: 28
        }
      },
      '61': {
        start: {
          line: 121,
          column: 15
        },
        end: {
          line: 121,
          column: 25
        }
      },
      '62': {
        start: {
          line: 122,
          column: 2
        },
        end: {
          line: 129,
          column: 4
        }
      },
      '63': {
        start: {
          line: 123,
          column: 25
        },
        end: {
          line: 123,
          column: 58
        }
      },
      '64': {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 124,
          column: 49
        }
      },
      '65': {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 128,
          column: 7
        }
      },
      '66': {
        start: {
          line: 126,
          column: 6
        },
        end: {
          line: 126,
          column: 26
        }
      },
      '67': {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 127,
          column: 22
        }
      },
      '68': {
        start: {
          line: 130,
          column: 2
        },
        end: {
          line: 132,
          column: 4
        }
      },
      '69': {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 131,
          column: 40
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 55
          },
          end: {
            line: 1,
            column: 56
          }
        },
        loc: {
          start: {
            line: 1,
            column: 151
          },
          end: {
            line: 117,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 7,
            column: 22
          },
          end: {
            line: 7,
            column: 23
          }
        },
        loc: {
          start: {
            line: 7,
            column: 34
          },
          end: {
            line: 19,
            column: 3
          }
        },
        line: 7
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 9,
            column: 44
          },
          end: {
            line: 9,
            column: 45
          }
        },
        loc: {
          start: {
            line: 9,
            column: 52
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 9
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 20
          }
        },
        loc: {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 20
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 32,
            column: 22
          },
          end: {
            line: 32,
            column: 23
          }
        },
        loc: {
          start: {
            line: 32,
            column: 38
          },
          end: {
            line: 62,
            column: 3
          }
        },
        line: 32
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 44,
            column: 7
          },
          end: {
            line: 44,
            column: 8
          }
        },
        loc: {
          start: {
            line: 44,
            column: 20
          },
          end: {
            line: 61,
            column: 5
          }
        },
        line: 44
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 50,
            column: 96
          },
          end: {
            line: 50,
            column: 97
          }
        },
        loc: {
          start: {
            line: 50,
            column: 104
          },
          end: {
            line: 60,
            column: 7
          }
        },
        line: 50
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 63,
            column: 20
          },
          end: {
            line: 63,
            column: 21
          }
        },
        loc: {
          start: {
            line: 63,
            column: 36
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 63
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 90,
            column: 23
          },
          end: {
            line: 90,
            column: 24
          }
        },
        loc: {
          start: {
            line: 90,
            column: 35
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 90
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 94,
            column: 18
          },
          end: {
            line: 94,
            column: 19
          }
        },
        loc: {
          start: {
            line: 94,
            column: 30
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 94
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 96,
            column: 92
          },
          end: {
            line: 96,
            column: 93
          }
        },
        loc: {
          start: {
            line: 96,
            column: 100
          },
          end: {
            line: 114,
            column: 5
          }
        },
        line: 96
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 104,
            column: 97
          },
          end: {
            line: 104,
            column: 98
          }
        },
        loc: {
          start: {
            line: 104,
            column: 106
          },
          end: {
            line: 109,
            column: 9
          }
        },
        line: 104
      },
      '12': {
        name: 'reportWorkflowCtrl_edit',
        decl: {
          start: {
            line: 119,
            column: 9
          },
          end: {
            line: 119,
            column: 32
          }
        },
        loc: {
          start: {
            line: 119,
            column: 83
          },
          end: {
            line: 133,
            column: 1
          }
        },
        line: 119
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 122,
            column: 24
          },
          end: {
            line: 122,
            column: 25
          }
        },
        loc: {
          start: {
            line: 122,
            column: 36
          },
          end: {
            line: 129,
            column: 3
          }
        },
        line: 122
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 125,
            column: 94
          },
          end: {
            line: 125,
            column: 95
          }
        },
        loc: {
          start: {
            line: 125,
            column: 100
          },
          end: {
            line: 128,
            column: 5
          }
        },
        line: 125
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 130,
            column: 22
          },
          end: {
            line: 130,
            column: 23
          }
        },
        loc: {
          start: {
            line: 130,
            column: 34
          },
          end: {
            line: 132,
            column: 3
          }
        },
        line: 130
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 47,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 47,
            column: 7
          }
        }, {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 47,
            column: 7
          }
        }],
        line: 45
      },
      '1': {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }, {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }],
        line: 51
      },
      '2': {
        loc: {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }, {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }],
        line: 69
      },
      '3': {
        loc: {
          start: {
            line: 69,
            column: 10
          },
          end: {
            line: 69,
            column: 52
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 69,
            column: 10
          },
          end: {
            line: 69,
            column: 26
          }
        }, {
          start: {
            line: 69,
            column: 30
          },
          end: {
            line: 69,
            column: 52
          }
        }],
        line: 69
      },
      '4': {
        loc: {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        }, {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        }],
        line: 75
      },
      '5': {
        loc: {
          start: {
            line: 91,
            column: 12
          },
          end: {
            line: 91,
            column: 46
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 91,
            column: 12
          },
          end: {
            line: 91,
            column: 27
          }
        }, {
          start: {
            line: 91,
            column: 31
          },
          end: {
            line: 91,
            column: 46
          }
        }],
        line: 91
      },
      '6': {
        loc: {
          start: {
            line: 97,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 97,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        }, {
          start: {
            line: 97,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        }],
        line: 97
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_w2usndpe4.s[0]++;
angular.module('app').controller('reportWorkflowCtrl', function ($scope, $stateParams, $deltahttp, $translate, $CRUDService, SweetAlert, $filter, $uibModal) {
  cov_w2usndpe4.f[0]++;

  var PATH = (cov_w2usndpe4.s[1]++, 'User');
  var PATHWORKFLOW = (cov_w2usndpe4.s[2]++, 'Workflow');

  cov_w2usndpe4.s[3]++;
  $scope.tab_workflow = 5;

  cov_w2usndpe4.s[4]++;
  $scope.getAllUser = function () {
    cov_w2usndpe4.f[1]++;
    cov_w2usndpe4.s[5]++;

    $scope.isloading = true;
    cov_w2usndpe4.s[6]++;
    $CRUDService.getAll(PATH, { get: 'all' }, function (data) {
      cov_w2usndpe4.f[2]++;
      cov_w2usndpe4.s[7]++;

      for (var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var el = _ref;
        cov_w2usndpe4.s[8]++;

        el.TYPEUSER = el.TYPEUSER == 1;
        cov_w2usndpe4.s[9]++;
        el.picture = $deltahttp.getUserPicture(el.id);
      }
      cov_w2usndpe4.s[10]++;
      $scope.listUser = data;
      cov_w2usndpe4.s[11]++;
      $scope.listUser.push({ id: 0 });
      cov_w2usndpe4.s[12]++;
      $scope.isloading = false;
      cov_w2usndpe4.s[13]++;
      $scope.getAll();
    });
  };
  cov_w2usndpe4.s[14]++;
  $scope.addStep = function () {
    cov_w2usndpe4.f[3]++;

    var id = (cov_w2usndpe4.s[15]++, $scope.workflow.id);
    var level = (cov_w2usndpe4.s[16]++, $scope.workflow.LIST_STEP.length + 1);
    cov_w2usndpe4.s[17]++;
    $scope.editStep({
      ID_WORKFLOW: id,
      NAME: '',
      COLOR: '0,0,0',
      id: 0,
      LEVEL: level,
      IDUSER: 0
    });
  };
  cov_w2usndpe4.s[18]++;
  $scope.deleteStep = function (item) {
    cov_w2usndpe4.f[4]++;
    cov_w2usndpe4.s[19]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_w2usndpe4.f[5]++;
      cov_w2usndpe4.s[20]++;

      if (isconfirm) {
        cov_w2usndpe4.b[0][0]++;
        cov_w2usndpe4.s[21]++;

        return;
      } else {
        cov_w2usndpe4.b[0][1]++;
      }
      cov_w2usndpe4.s[22]++;
      $scope.isloading = true;
      var validateItem = (cov_w2usndpe4.s[23]++, angular.copy(item));
      cov_w2usndpe4.s[24]++;
      $CRUDService.delet(PATHWORKFLOW, { action: 'supp', valeur: $filter('json')(validateItem) }, function (data) {
        cov_w2usndpe4.f[6]++;
        cov_w2usndpe4.s[25]++;

        if (data < 0) {
          cov_w2usndpe4.b[1][0]++;
          cov_w2usndpe4.s[26]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
          });
          cov_w2usndpe4.s[27]++;
          $scope.isloading = false;
          cov_w2usndpe4.s[28]++;
          return;
        } else {
          cov_w2usndpe4.b[1][1]++;
        }
        cov_w2usndpe4.s[29]++;
        $scope.getAll();
      });
    });
  };
  cov_w2usndpe4.s[30]++;
  $scope.editStep = function (item) {
    cov_w2usndpe4.f[7]++;
    cov_w2usndpe4.s[31]++;

    $scope.selectedStep = angular.copy(item);
    cov_w2usndpe4.s[32]++;
    $scope.listFilterUser = [];
    var listUser = (cov_w2usndpe4.s[33]++, $scope.workflow.LIST_STEP);
    cov_w2usndpe4.s[34]++;
    for (var _iterator2 = $scope.listUser, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var user = _ref2;

      var items = (cov_w2usndpe4.s[35]++, $filter('filter')(listUser, { IDUSER: user.id }, true));
      cov_w2usndpe4.s[36]++;
      if ((cov_w2usndpe4.b[3][0]++, items.length > 0) && (cov_w2usndpe4.b[3][1]++, items[0].id != item.id)) {
        cov_w2usndpe4.b[2][0]++;
        cov_w2usndpe4.s[37]++;

        continue;
      } else {
        cov_w2usndpe4.b[2][1]++;
      }
      cov_w2usndpe4.s[38]++;
      $scope.listFilterUser.push(user);
    }
    var u = (cov_w2usndpe4.s[39]++, $filter('filter')($scope.listUser, { id: $scope.selectedStep.IDUSER }, true));
    cov_w2usndpe4.s[40]++;
    if (u.length > 0) {
      cov_w2usndpe4.b[4][0]++;
      cov_w2usndpe4.s[41]++;

      $scope.selectedStep.IDUSER = u[0];
    } else {
      cov_w2usndpe4.b[4][1]++;
      cov_w2usndpe4.s[42]++;

      $scope.selectedStep.IDUSER = $scope.listUser[$scope.listUser.length - 1];
    }

    cov_w2usndpe4.s[43]++;
    $uibModal.open({
      templateUrl: 'app/views/report_type/workflow/edit.html',
      controller: reportWorkflowCtrl_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };
  cov_w2usndpe4.s[44]++;
  $scope.getStepList = function () {
    cov_w2usndpe4.f[8]++;
    cov_w2usndpe4.s[45]++;

    return ((cov_w2usndpe4.b[5][0]++, $scope.workflow) || (cov_w2usndpe4.b[5][1]++, { LIST_STEP: [] })).LIST_STEP;
  };
  cov_w2usndpe4.s[46]++;
  $scope.loading = true;
  cov_w2usndpe4.s[47]++;
  $scope.getAll = function () {
    cov_w2usndpe4.f[9]++;
    cov_w2usndpe4.s[48]++;

    $scope.loading = false;
    cov_w2usndpe4.s[49]++;
    $CRUDService.getAll(PATHWORKFLOW, { get: 'document', id: $scope.selectedItemWorflow.id }, function (data) {
      cov_w2usndpe4.f[10]++;
      cov_w2usndpe4.s[50]++;

      if (data == 'null') {
        cov_w2usndpe4.b[6][0]++;

        var workflow = (cov_w2usndpe4.s[51]++, {
          NAME: '',
          TYPE: '8',
          COLOR: '0, 0, 0',
          ID_REFERENCE: $scope.selectedItemWorflow.id
        });
        cov_w2usndpe4.s[52]++;
        $CRUDService.save(PATHWORKFLOW, { action: 'MiseAJour', valeur: angular.toJson(workflow) }, function (data_) {
          cov_w2usndpe4.f[11]++;
          cov_w2usndpe4.s[53]++;

          workflow.id = data_;
          cov_w2usndpe4.s[54]++;
          workflow.LIST_STEP = [];
          cov_w2usndpe4.s[55]++;
          $scope.workflow = workflow;
          cov_w2usndpe4.s[56]++;
          $scope.loading = false;
        });
      } else {
        cov_w2usndpe4.b[6][1]++;
        cov_w2usndpe4.s[57]++;

        $scope.workflow = data;
        cov_w2usndpe4.s[58]++;
        $scope.loading = false;
      }
    });
  };
  cov_w2usndpe4.s[59]++;
  $scope.getAllUser();
});

function reportWorkflowCtrl_edit($scope, $uibModalInstance, $filter, $CRUDService) {
  cov_w2usndpe4.f[12]++;
  cov_w2usndpe4.s[60]++;

  $scope.error_code = false;
  var PATH = (cov_w2usndpe4.s[61]++, 'Workflow');
  cov_w2usndpe4.s[62]++;
  $scope.setValidData = function () {
    cov_w2usndpe4.f[13]++;

    var validateItem = (cov_w2usndpe4.s[63]++, angular.copy($scope.selectedStep));
    cov_w2usndpe4.s[64]++;
    validateItem.IDUSER = validateItem.IDUSER.id;
    cov_w2usndpe4.s[65]++;
    $CRUDService.save(PATH, { action: 'MiseAJourStep', valeur: $filter('json')(validateItem) }, function () {
      cov_w2usndpe4.f[14]++;
      cov_w2usndpe4.s[66]++;

      $scope.closeModal();
      cov_w2usndpe4.s[67]++;
      $scope.getAll();
    });
  };
  cov_w2usndpe4.s[68]++;
  $scope.closeModal = function () {
    cov_w2usndpe4.f[15]++;
    cov_w2usndpe4.s[69]++;

    $uibModalInstance.dismiss('cancel');
  };
}